import PathForMixin from '@/mixins/PathFor'
import WordingMixin from '@/mixins/Wording'
import ScrollMixin from '@/mixins/Scroll'
import TimeMixin from '@/mixins/Time'
import SizesMixin from '@/mixins/Sizes'
import EventHubMixin from '@/mixins/EventHub'

import AppPicture from '@/components/app-picture/'
import AppInteractionBarrels from '@/components/app-interaction-barrels/'
import AppInteractionTank from '@/components/app-interaction-tank/'
import AppInteractionSimulation from '@/components/app-interaction-simulation/'
import AppInteractionDroning from '@/components/app-interaction-droning/'
import AppButtonCircle from '@/components/app-button-circle/'

export default
{
    name: 'app-page-content',

    mixins:
    [
        PathForMixin,
        WordingMixin,
        ScrollMixin,
        TimeMixin,
        SizesMixin,
        EventHubMixin
    ],

    components:
    {
        AppPicture,
        AppInteractionBarrels,
        AppInteractionTank,
        AppInteractionSimulation,
        AppInteractionDroning,
        AppButtonCircle
    },

    data()
    {
        return {
            content: null,

            isClosing: false,

            closeGrayCircleLength: 0,
            closeWhiteCircleStart: - 0.25,
            closeWhiteCircleLength: 0,
            closeYellowCircleLength: 0,
            closeActive: false,

            interactionGrayCircleLength: 0,
            interactionWhiteCircleStart: - 0.25,
            interactionWhiteCircleLength: 0,
            interactionActive: false
        }
    },

    created()
    {
        this.content = this.wording[this.$route.meta.slug]

        this.scrollProgress = {}
        this.scrollProgress.target = 0
        this.scrollProgress.bodyHeight = 800
        this.scrollAtEnd = false
    },

    mounted()
    {
        this.onResize()
        this.$eventHub.$emit('experience.updateBodyHeight')

        window.addEventListener('keydown', this.onKeyDown)

        window.setTimeout(() =>
        {
            this.closeGrayCircleLength = 1
            this.interactionGrayCircleLength = 1
        }, 500)

        window.setTimeout(() =>
        {
            this.closeActive = true
            this.interactionActive = true
        }, 1000)
    },

    destroyed()
    {
        window.removeEventListener('keydown', this.onKeyDown)
    },

    methods:
    {
        onCloseMouseEnter(_event)
        {
            if(!this.$root.config.platform.mobile)
            {
                this.closeWhiteCircleStart = - 1.25
                this.closeWhiteCircleLength = 1
                this.closeYellowCircleLength = 0
            }

            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onCloseMouseLeave()
        {
            if(!this.$root.config.platform.mobile)
            {
                this.closeWhiteCircleStart = - 0.25
                this.closeWhiteCircleLength = 0
                this.closeYellowCircleLength = this.scrollProgress.target
            }

            this.$eventHub.$emit('grid.unfocusItem')
        },

        onCloseClick()
        {
            this.close()
        },

        onInteractionMouseEnter(_event)
        {
            if(!this.$root.config.platform.mobile)
            {
                this.interactionWhiteCircleStart = - 1.25
                this.interactionWhiteCircleLength = 1
                this.interactionYellowCircleLength = 0
            }

            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onInteractionMouseLeave()
        {
            if(!this.$root.config.platform.mobile)
            {
                this.interactionWhiteCircleStart = - 0.25
                this.interactionWhiteCircleLength = 0
                this.interactionYellowCircleLength = this.scrollProgress.target
            }

            this.$eventHub.$emit('grid.unfocusItem')
        },

        onInteractionClick()
        {
            const target = this.scrollProgress.bodyHeight - this.sizes.height
            const delta = Math.abs(this.scroll.current - target)
            const duration = 0.5 + delta / 1000 / 5

            this.animateTo(target, duration)
        },

        onKeyDown(_event)
        {
            if(_event.keyCode === 27)
            {
                this.close()
            }
        },

        onScroll()
        {
            this.updateScrollProgress()
        },

        onResize()
        {
            this.scrollProgress.bodyHeight = this.$root.config.scrollType === 'body' ? document.querySelector('#app').offsetHeight : document.body.offsetHeight
            this.updateScrollProgress()
        },

        close()
        {
            const duration = 0.5 + this.scroll.current / 1000 / 5
            this.animateTo(0, duration)

            this.isClosing = true

            window.setTimeout(() =>
            {
                this.$router.push({ name: 'slider' })
            }, duration * 1000)
        },

        updateScrollProgress()
        {
            if(this.isClosing)
            {
                return
            }

            this.scrollProgress.target = this.scroll.current / (this.scrollProgress.bodyHeight - this.sizes.height)
            this.scrollProgress.target = Math.min(Math.max(this.scrollProgress.target, 0), 1)

            this.closeYellowCircleLength = this.scrollProgress.target

            if(this.scrollProgress.target === 1)
            {
                if(!this.scrollAtEnd)
                {
                    this.$eventHub.$emit('grid.focusItem', this.$el.querySelector('.js-frame'))
                    this.interactionGrayCircleLength = 0
                    this.interactionActive = false
                    this.scrollAtEnd = true
                }
            }
            else
            {
                if(this.scrollAtEnd)
                {
                    this.$eventHub.$emit('grid.unfocusItem')
                    this.interactionGrayCircleLength = 1
                    this.interactionActive = true
                    this.scrollAtEnd = false
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-content/script.js